import { combineReducers } from "redux"
import { reduceFormData } from './form-data';

export const reducer = combineReducers({
    formData: reduceFormData,
});

export default reducer;